import {
 Box,
 Button,
 FormControlLabel,
 Switch,
 TextField,
 Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import QRCodeSVG from 'react-qr-code';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { RootState } from '../../../redux/store';
import { identitySetTotpStart } from '../../../redux/identity/identitySlice';
import { getCookieCustom } from '../../../utils/cookies';

const TwoFactorSection = () => {
 const dispatch = useAppDispatch();
 const { t } = useTranslation();
 const { qrCode, loading } = useAppSelector(
  (state: RootState) => state.identity,
 );
 const { user } = useAppSelector((state: RootState) => state.users);

 const handleGenerateQR = () => {
  const userId = getCookieCustom('user_id');
  if (userId) {
   dispatch(identitySetTotpStart({ userid: userId, sessionId: undefined }));
  }
 };

 return (
  <Box
   sx={{
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    // pt: 2,
    // borderTop: 1,
    // borderTopColor: (th) => th.palette.kemek.lightestGray,
   }}
  >
   <Box
    sx={{
     display: 'flex',
     flexDirection: 'column',
     gap: '12px',
    }}
   >
    <FormControlLabel
     control={
      <Switch
       checked={user?.TwoFAEnabled || false}
       disabled={true}
       color="primary"
      />
     }
     label={t('user.twoFactor.title')}
     sx={{ m: 0 }}
    />
    {!qrCode && (
     <Button
      variant="outlined"
      onClick={handleGenerateQR}
      disabled={loading?.identitySetTotp === true}
      size="medium"
      sx={{ display: 'flex', width: '100%', minHeight: 44 }}
     >
      {t('user.buttons.generateQR')}
     </Button>
    )}
    {qrCode && (
     <Box sx={{}}>
      <Box
       sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '48px',
        p: '12px',
        backgroundColor: (th) => th.palette.kemek.lightBlue,
       }}
      >
       <Box
        sx={{
         display: 'flex',
         flexDirection: 'column',
         gap: '12px',
        }}
       >
        <Typography sx={{ fontSize: 16 }}>
         {t('user.twoFactor.qrCode')}
        </Typography>
        <Typography sx={{ fontSize: 12 }}>
         {t('user.twoFactor.qrCodeDescription')}
        </Typography>
       </Box>
       <QRCodeSVG
        value={qrCode?.uri || ''}
        size={256}
        style={{ maxWidth: '100%', height: 'auto' }}
       />
      </Box>
     </Box>
    )}
   </Box>
  </Box>
 );
};

export default TwoFactorSection;

